import React, { useState } from 'react';
import styled from 'styled-components';
import { AnalyticsDetails } from "./AnalyticsDetails";
import { UserDetails } from "./UserDetails";
import { SubscriptionView } from "./Subscription/SubscriptionView";
import { useParams } from "react-router";

const TabBar = styled.div`
    display: flex;
    gap: 4px;
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 24px;
`;

const TabBtn = styled.button`
    padding: 10px 18px;
    background: none;
    border: none;
    border-bottom: 2px solid ${({ $active }) => $active ? "#6366f1" : "transparent"};
    margin-bottom: -1px;
    font-size: 0.875rem;
    font-weight: ${({ $active }) => $active ? "700" : "500"};
    color: ${({ $active }) => $active ? "#6366f1" : "#64748b"};
    cursor: pointer;
    font-family: "Inter", system-ui, sans-serif;
    transition: color 120ms, border-color 120ms;
    &:hover { color: #6366f1; }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 20px;
    align-items: start;
    @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

function getSectionIndex(section) {
    return section === "subscription" ? 1 : 0;
}

const AccountDetails = () => {
    const { section } = useParams();
    const [tab, setTab] = useState(getSectionIndex(section));

    return (
        <div>
            <TabBar>
                <TabBtn $active={tab === 0} onClick={() => setTab(0)}>General</TabBtn>
                <TabBtn $active={tab === 1} onClick={() => setTab(1)}>Subscription</TabBtn>
            </TabBar>

            {tab === 0 && (
                <Grid>
                    <UserDetails />
                    <AnalyticsDetails />
                </Grid>
            )}

            {tab === 1 && <SubscriptionView />}
        </div>
    );
};

export default AccountDetails;
